import * as filter from "./filters";
const pricingRules = require('./pricingRules');
import moment from "moment"

let USER_TYPE;
const DEFAULT_VAT_RATE = 0.2;
function organiseOrders(orders, userType, networks) {
  USER_TYPE = userType;
  return orders
    .map((order) =>
      order.negotiation ? returnOrganisedNegotiationItem(order) : returnOrganisedOfferItem(order, networks)
    )
    .flat();
}

// Also polyfill Array.isArray:
if (!Array.isArray) {
  Array.isArray = function (arg) {
    return Object.prototype.toString.call(arg) === "[object Array]";
  };
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/flat#Polyfill
if (!Array.prototype.flat) {
  Array.prototype.flat = function (depth) {
    var flattened = [];
    (function flat(array, depth) {
      for (var i = 0; i < array.length; i++) {
        var el = array[i];
        if (Array.isArray(el) && depth > 0) {
          flat(el, depth - 1);
        } else {
          flattened.push(el);
        }
      }
    })(this, Math.floor(depth) || 1);
    return flattened;
  };
}

function returnOrganisedNegotiationItem(order) {
    const { negotiation } = order;
    let offerTotal;
    const { contractNumbers, pickupNumbers, liftingNumbers } = order;
    const organisedItem = {
      _id: order._id,
      edited: order.edited,
      created: order.created,
      status: order.status,
      orderId: order.orderId,
      date: filter.standardDateFormat(order.created),
      fuelType: negotiation.fuel.type,
      premium: negotiation.premium,
      orderCancelled: order.cancelled,
      delivery_location: "N/A",
      deliveryDate: "N/A",
      offer_type: "Spot",
      vat: order.vat,
      isNegotiation: true,
      createdby_id: negotiation.createdby_id,
      adjustment: 0,
      contractNumber: negotiation.contractNumber,
      releaseNumber: negotiation.releaseNumber,
      movementNumber: negotiation.movementNumber,
      deliveryNotes: negotiation.deliveryNotes,
    };

    if (order.counter_offer_id) {//If we have a counter_offer_id we also have a counter offer that was accepted
        const counterOffer = negotiation.counterOffers.find(counterOffer => counterOffer._id === order.counter_offer_id);
        organisedItem.quantity = filter.volumeFormat(counterOffer.quantity);

        organisedItem.price = filter.priceFormat(counterOffer.type_id === "TRACKING" ? counterOffer.livePrice : counterOffer.price);
        organisedItem.credit_days = filter.creditDaysFormat(counterOffer.credit.credit.days);
        organisedItem.measurement = filter.fuelMeasurementType(counterOffer.fuel_measurement_id);
        offerTotal =
          ((counterOffer.type_id === "TRACKING" ? counterOffer.livePrice : counterOffer.price) *
            counterOffer.quantity) /
          100;
        // required fields for edit order
        organisedItem.liftingPeriod = getLiftingPeriod(counterOffer, negotiation.created);

    } else {//Otherwise normal negotiation was accepted
        organisedItem.quantity = filter.volumeFormat(negotiation.quantity);

        organisedItem.price = filter.priceFormat(negotiation.type_id === "TRACKING" ? negotiation.livePrice : negotiation.price);
        organisedItem.credit_days = negotiation.credit != null ? filter.creditDaysFormat(negotiation.credit.days) : 'N/A';
        organisedItem.measurement = filter.fuelMeasurementType(negotiation.fuel_measurement_id);
        offerTotal =
          ((negotiation.type_id === "TRACKING"
            ? parseFloat(negotiation.livePrice)
            : parseFloat(negotiation.price)) *
            filter.removeComma(organisedItem.quantity)) /
          100;
        // required fields for edit order
        organisedItem.liftingPeriod = getLiftingPeriod(negotiation, negotiation.created);
    }

    organisedItem.bioPrice = negotiation.fuel.type === "NOT4SALE" ? "Split" : "Straight";
    organisedItem.fuel = !negotiation.terminal ? "Network" : filter.fuelType(negotiation.fuel._id);
    organisedItem.terminal = getNegotiationTerminalName(order);

    organisedItem.pricingMethod = filter.pricingMethod(negotiation.type_id);
    const totalExVat = offerTotal;
    const vatRate = order.vat ? order.vat : DEFAULT_VAT_RATE;
    const vatCost = vatRate * totalExVat;
    const totalIncVat = vatCost + totalExVat;

    organisedItem.vatCost = filter.priceFormat(vatCost);
    organisedItem.totalIncVat = filter.priceFormat(totalIncVat);
    organisedItem.offerTotal = filter.priceFormat(offerTotal);
    organisedItem.totalExVat = filter.priceFormat(totalExVat);

    organisedItem.account = getRelevantAccountName(order);
    organisedItem.seller = negotiation.seller;
    organisedItem.product_type = filter.storageType(negotiation.fuel.type);

    if (organisedItem.product_type === 'Bunkering')
        organisedItem.bunkeringAccountNumber = organisedItem.reference;

    if (contractNumbers && contractNumbers.length > 0){
        const negotiationOrderNumber = contractNumbers.find(item => item.negotiationId === order.negotiation._id);
        if (negotiationOrderNumber) organisedItem.orderNumber = negotiationOrderNumber.referenceNumber;
    }

    if (pickupNumbers && pickupNumbers.length > 0){
        const negotiationReleaseNumber = pickupNumbers.find(item => item.negotiationId === order.negotiation._id);
        if (negotiationReleaseNumber) organisedItem.releaseNumber = negotiationReleaseNumber.referenceNumber;
    }

    if (liftingNumbers && liftingNumbers.length > 0){
        const negotiationMovementNumber = liftingNumbers.find(item => item.negotiationId === order.negotiation._id);
        if (negotiationMovementNumber) organisedItem.movementNumber = negotiationMovementNumber.referenceNumber;
    }
    
    if (organisedItem.product_type === 'Bunkering') {
        organisedItem.bunkeringAccountNumber = order.client_reference;
        organisedItem.reference = "-";
    } else {
        organisedItem.reference = order.client_reference;
        organisedItem.bunkeringAccountNumber = "-";
    }
    
    return organisedItem;
}

function returnOrganisedOfferItem(order, networks) {
  const offers = [];
  for (let i = 0; i < order.offers.length; i++) {
    let totalExVat;
    const currentOffer = order.offers[i];
    const organisedItem = {
      _id: order._id,
      offerId: currentOffer._id,
      collectionTime: currentOffer.collectionTime,
      edited: order.edited,
      orderId: order.offers.length > 1 ? `${order.orderId}-${i + 1}` : order.orderId,
      date: filter.standardDateFormat(order.created),
      reference: order.client_reference ? order.client_reference : "-",
      premium: currentOffer.premium,
      deliveryDate: order.deliveryDate,
      isNegotiation: false,
      // required fields for edit order
      vat: order.vat,
      created: order.created,
      status: order.status,
      orderCancelled: order.cancelled,
      fuelType: currentOffer.fuel.type,
      adjustment: currentOffer.adjustment ? currentOffer.adjustment : 0,
      contractNumber: currentOffer.contractNumber,
      releaseNumber: currentOffer.releaseNumber,
      movementNumber: currentOffer.movementNumber,
      orderNotes: order.orderNotes,
      liftingPeriod: getLiftingPeriod(currentOffer, order.created),
    };
    if (order.offers.length > 1) organisedItem.originalOrderId = order.orderId;

    if (order.location) {
      //Delivered In specific stuff
      organisedItem.delivery_location = order.location.name;
      organisedItem.offer_type = "Delivered In";
      organisedItem.deliveryDate = filter.dateFormat(order.deliveryDate) || "N/A";
      organisedItem.exrack = order.haulageRate ? filter.priceFormat(Number(currentOffer.price)) : "N/A";
      organisedItem.haulage = order.haulageRate ? filter.priceFormat(order.haulageRate) : "N/A";
      organisedItem.price = filter.priceFormat(currentOffer.price + order.haulageRate);
      organisedItem.offerTotal = filter.priceFormat(
        ((currentOffer.price + order.haulageRate) * currentOffer.quantityOrdered) / 100
      );
      totalExVat = order.offers.reduce((total, { price, quantityOrdered }) => {
        return total + Number((((price + order.haulageRate) * quantityOrdered) / 100).toFixed(2));
      }, 0);
    } else {
      //Normal Offer order stuff
      organisedItem.delivery_location = "N/A";
      organisedItem.deliveryDate = "N/A";

      organisedItem.price = filter.priceFormat(currentOffer.price);
      organisedItem.offerTotal = filter.priceFormat((currentOffer.price * currentOffer.quantityOrdered) / 100);
      totalExVat = order.offers.reduce((total, { price, quantityOrdered }) => {
        return total + Number(((price * quantityOrdered) / 100).toFixed(2));
      }, 0);
    }
    const vatRate = order.vat ? order.vat : DEFAULT_VAT_RATE;
    const vatCost = vatRate * totalExVat;
    const totalIncVat = vatCost + totalExVat;
    organisedItem.totalIncVat = filter.priceFormat(totalIncVat);
    organisedItem.vatCost = filter.priceFormat(vatCost);

    organisedItem.totalExVat = filter.priceFormat(totalExVat);
    organisedItem.credit_days = currentOffer.credit ? filter.creditDaysFormat(currentOffer.credit.days) : "N/A";
    organisedItem.fuel = !currentOffer.terminal ? "Network" : filter.fuelType(currentOffer.fuel_id);
    organisedItem.product_id = currentOffer.fuel_id;
    organisedItem.bioPrice = currentOffer.fuel.type === "NOT4SALE" ? "Split" : "Straight";

    organisedItem.pricingMethod = filter.pricingMethod(currentOffer.type_id);
    organisedItem.quantity = filter.volumeFormat(currentOffer.quantityOrdered);
    organisedItem.offer_type = filter.offerType(currentOffer.isContract ? currentOffer.isContract : false);
    organisedItem.measurement = filter.fuelMeasurementType(currentOffer.fuel_measurement_id);

    organisedItem.product_type = filter.storageType(currentOffer.storage_type_id);
    organisedItem.terminal = getOfferTerminalName(currentOffer, networks);
    organisedItem.account = getRelevantAccountName(order);

    organisedItem.seller = currentOffer.seller;
    organisedItem.basket_id = order.basket_id;

    organisedItem.bunkeringAccountNumber = getBunkeringAccountNumber(organisedItem, order, i);

    organisedItem.pricingEngineEnabled = currentOffer.pricingEngineEnabled;
    if (currentOffer.pricingEngineEnabled) organisedItem.pricingAuditTrail = currentOffer.pricingAuditTrail;

    const { contractNumber, releaseNumber, movementNumber } = getHarvestOrderNumbers(currentOffer._id, order);

    if (contractNumber) {
      organisedItem.contractNumber = contractNumber;
      organisedItem.orderNumber = contractNumber;
    }
  
    if (releaseNumber) { 
      organisedItem.releaseNumber = releaseNumber;
    }

    if (movementNumber) {
      organisedItem.movementNumber = movementNumber;
    }

    offers.push(organisedItem);
  }
  return offers;
}

function getHarvestOrderNumbers(offerId, { contractNumbers, pickupNumbers, liftingNumbers }) {
  let contractNumber, releaseNumber, movementNumber;
  if (contractNumbers && contractNumbers.length > 0) {
    const c = contractNumbers.find((item) => item.offerId === offerId);
    contractNumber = c ? c.referenceNumber : null;
  }

  if (pickupNumbers && pickupNumbers.length > 0) {
    const r = pickupNumbers.find((item) => item.offerId === offerId);
    releaseNumber = r ? r.referenceNumber : null;
  }

  if (liftingNumbers && liftingNumbers.length > 0) {
    const l = liftingNumbers.find((item) => item.offerId === offerId);
    movementNumber = l ? l.referenceNumber : null;
  }
  return { contractNumber, releaseNumber, movementNumber };
}

function getOfferTerminalName(offer, networks){
    if(offer.networkId && networks){
        const network = networks.find(n => n._id === offer.networkId);
        return network ? network.name : "N/A";
    } else if(offer.network_id){ // @TO-DO: Remove the following condition after orders have been updated with networkId
        if(offer.network_id === "KEY") return "Keyfuels";
        return "UK Fuels";
    } else if(offer.fuel.name === "UK Fuels") return "UK Fuels";
    else if(offer.fuel.name === "Keyfuels") return "Keyfuels";
    return offer.terminal.name;
}

function getRelevantAccountName(order){
    if(USER_TYPE === 'buyer'){
        if(order.offers && order.offers[0]){
            return order.offers[0].seller.name;
        } else if(order.negotiation && order.negotiation.seller){
            return order.negotiation.seller.name;
        } else{
            return "N/A";
        }
    } else {
        if(order.buyer){
            return order.buyer.name;
        } else {
            return "N/A";
        }
    }
}

function getNegotiationTerminalName(order){
    
    if (order.negotiation.fuel && order.negotiation.fuel.type === "BUNKERING")
        return order.negotiation.fuel.name; //any bunkering order will have the terminal set as the fuel name


    if (order.counter_offer_id) {
        const counterOffer = order.negotiation.counterOffers.find(counterOffer => counterOffer._id === order.counter_offer_id);
        return counterOffer.terminal ? counterOffer.terminal.name : "N/A"; //if there was an accepted counter offer check the name of the new terminal
    } 

    return order.negotiation.terminal ? order.negotiation.terminal.name : "N/A"; //if its not bunkering and not an accepted counter offer
                                                                                 // the terminal name will be the one on the order.teminal object
}

function filterPricingRulesForOrderReceipt(orderItem, marketWindow, productIds, auditTrailType){
    switch (auditTrailType){
        case 'MARKET_DATA':
            return pricingRules.getMarketDataOrderRules(orderItem, marketWindow, productIds);
        case 'PRODUCT_SPECIFIC': {
            return pricingRules.getProductSpecificRules(orderItem, productIds);
        }
        default: {
            return [
                ...pricingRules.getMarketDataOrderRules(orderItem, marketWindow, productIds),
                ...pricingRules.getProductSpecificRules(orderItem, productIds)
            ];
        }
    }
}

function getBunkeringAccountNumber(organisedItem, order, orderItemIndex) {
  // Applies to spot bunkering offers only
  if (organisedItem.product_type !== "Bunkering" || organisedItem.offer_type === "Contract") {
    return "-";
  }
  if (order.offers[orderItemIndex].offerReference != null) {
    return order.offers[orderItemIndex].offerReference;
  }
  if (organisedItem.reference.includes(";") && order.offers.length > 1) {
    // For legacy multi-offer orders where the order reference was an aggregation of the individual acc references
    return organisedItem.reference.split(";")[orderItemIndex];
  }

  return organisedItem.reference; //For legacy single offer orders where the acc reference was the order reference
}

function getLiftingPeriod(offer, orderCreated = null) {
  if (!offer.terminal_id) {
    return [];
  }
  if (offer.liftingPeriod && offer.liftingPeriod.length === 2) {
    return offer.liftingPeriod;
  }
  return convertCollectionTimeToLiftingPeriod(offer.collectionTime, orderCreated);
}

function getOrderStatusDisplay(order, page = "") {
  const orderStatusObject = {
    text: '',
    textColor: '',
    showEditOptionOnly: false,
  }
  if (order.orderCancelled) {
    orderStatusObject.text = "Order Cancelled"
    orderStatusObject.textColor = "danger"
    if (page === "purchaseHistory") {
      orderStatusObject.text = 'Cancelled'
    }
  } else {
    orderStatusObject.text = order.status === 'INCOMPLETE' ? 'Pending Confirmation' : 'Order Confirmed'
    orderStatusObject.textColor = orderStatusObject.text === 'Pending Confirmation' ? 'warning' : 'primary'
    if (page === "purchaseHistory") {
      orderStatusObject.text = orderStatusObject.text === 'Pending Confirmation' ? 'Pending' : 'Confirmed';
    }
  }
  if (orderStatusObject.text === 'Confirmed') {
    orderStatusObject.showEditOptionOnly = true
  }
  return orderStatusObject;
}

function convertCollectionTimeToLiftingPeriod(collectionTime, date = null) {
  let timePeriod1, timePeriod2;
  switch (collectionTime) {
    case 0:
      timePeriod1 = moment.parseZone(date);
      timePeriod2 = moment.parseZone(date);
      break;
    case 1:
      timePeriod1 = moment.parseZone(date).add(1, "days");
      timePeriod2 = moment.parseZone(date).add(1, "days");
      break;
    case 2:
      timePeriod1 = moment.parseZone(date).add(2, "days");
      timePeriod2 = moment.parseZone(date).add(2, "days");
      break;
    case 30:
      timePeriod1 = moment.parseZone(date);
      timePeriod2 = moment.parseZone(date).add(30, "days");
      break;
    default:
      timePeriod1 = moment.parseZone(date);
      timePeriod2 = moment.parseZone(date).add(collectionTime - 1, "days");
  }
  return [timePeriod1, timePeriod2];
}

export {
    organiseOrders,
    filterPricingRulesForOrderReceipt,
    getOrderStatusDisplay
};